import * as React from 'react';
import { Table } from '@tanstack/react-table';
import { Trash2 } from 'lucide-react';

import { DataTableActionBar } from '@/components/data-table/data-table-action-bar';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { BlockRule } from '@/lib/api/blockRules';

interface BlockRulesTableActionBarProps {
    table: Table<BlockRule>;
    onDeleteSelected: (ids: string[]) => void;
    isDeleting?: boolean;
}

export function BlockRulesTableActionBar({ table, onDeleteSelected, isDeleting }: BlockRulesTableActionBarProps) {
    const selectedRows = table.getFilteredSelectedRowModel().rows;

    const handleDelete = React.useCallback(() => {
        const ids = selectedRows.map((row) => row.original.id);
        onDeleteSelected(ids);
        table.toggleAllRowsSelected(false);
    }, [selectedRows, onDeleteSelected, table]);

    return (
        <DataTableActionBar table={table}>
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium">{selectedRows.length} selected</span>
                <Separator orientation="vertical" className="h-4" />
                <Button
                    variant="outline"
                    size="sm"
                    onClick={handleDelete}
                    disabled={isDeleting || selectedRows.length === 0}
                    className="text-red-600 hover:text-red-700"
                >
                    <Trash2 className="mr-1.5 h-3.5 w-3.5" />
                    Delete
                </Button>
            </div>
        </DataTableActionBar>
    );
}
